import script from "./KeyCodes.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyCodes.vue?vue&type=script&setup=true&lang=ts"

import "./KeyCodes.vue?vue&type=style&index=0&id=33f3720f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f3720f"]])

export default __exports__